import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/CookieBanner.css';

const CONSENT_KEY = 'pp_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  const accept  = () => { localStorage.setItem(CONSENT_KEY, 'accepted');  setVisible(false); };
  const decline = () => { localStorage.setItem(CONSENT_KEY, 'declined'); setVisible(false); };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <p className="cookie-text">
        This site uses cookies and Firebase Analytics to understand how visitors engage with the content.
        No personal data is sold or shared with third parties.{' '}
        <Link to="/privacy" className="cookie-link">Privacy policy</Link>
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-btn--decline" onClick={decline}>Decline</button>
        <button className="cookie-btn cookie-btn--accept" onClick={accept}>Accept</button>
      </div>
    </div>
  );
}
